import React from 'react';
import { Spin, Col, Button, Icon, Modal, Form, Row, Select, Input } from 'antd';
import { openNotification } from '../../util/notificaciones';
import CatalogosRequest from '../../services/Catalogos';
import UsuariosRequest from '../../services/Usuarios';
import SegmentosPVRequest from '../../services/SegmentosPV';
import BaseComponent from '../Common/BaseComponent';

const { Option } = Select;
const { confirm } = Modal;

class NewFormUsuarios extends BaseComponent {
    state = {
        cargando: false,
        bloquearBotones: false,
        cancelModalConfirm: false,
        arrPlazas: [],
        arrDrives: [],
        arrEstatus: [],
        arrSupervisores: [],
        plazaSelected: null,
        drivesSelected: [],
        mostrarDrive: false,
        disableComboDrive: true,
        filtros: {
            plaza: [],
            page: undefined
        },
        cargandoDrive: false,
        arrSegementos: [],
        segmentoSelected: null,
        usuarioInteraccion: false,
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if ((this.props.usuario_selected !== prevProps.usuario_selected)) {
            if (this.props.usuario_selected !== null) {
                // state.mostrarDrive = this.props.usuario_selected.rol !== 2 ? true : false
                state.mostrarDrive = (['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role")) && this.props.usuario_selected.rol !== 1);
                state.disableComboDrive = (this.props.usuario_selected.plaza !== null && this.props.modo !== 'ver') ? false : true

                let plaza_id = [];
                if(this.props.usuario_selected.rol === 4 || this.props.usuario_selected === 5)
                {
                    plaza_id = this.props.usuario_selected.plaza !== null ? [this.props.usuario_selected.plaza] : [];
                }
                else {
                    plaza_id.push(this.props.usuario_selected.plaza);
                }

                this.setState(state, () => {
                    if (this.props.modo !== 'configurar') {
                        CatalogosRequest.ListarSitios(plaza_id.toString(), this.props.usuario_selected.segmento)
                            .then(response => {
                                state.arrDrives = response.data;
                                if (['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role"))) {
                                    return SegmentosPVRequest.CargarSegmentosTabla()
                                } else {
                                    return Promise.resolve({ data: [] });
                                }
                            })
                            .then(segmento => {
                                state.arrSegementos = segmento.data;
                                this.setState(state)
                            })
                            .catch(err => {
                                openNotification(
                                    "Ha ocurrido un error al listar sitios y supervisores.",
                                    "Error al listar sitios y supervisores",
                                    false
                                )
                            })
                    }
                })
            }

            if (!state.arrPlazas.length) {
                const role = localStorage.getItem("role");
                this.setState({ cargando: true }, () => {
                    CatalogosRequest.ListarPlazas()
                        .then(response => {
                            state.arrPlazas = response.data;
                            if (['Administrador', 'SuperAdmin'].includes(role)) {
                                return SegmentosPVRequest.CargarSegmentosTabla()
                            } else {
                                return Promise.resolve({ data: [] });
                            }
                        })
                        .then(segmento => {
                            state.arrSegementos = segmento.data;

                            this.setState(state)
                        })
                        .catch(err => {
                            this.setState({ cargando: false })
                        })
                })
            }
        }
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    onChangePlaza = (value) => {
        let state = { ...this.state }
        let drive_temp = (this.props.usuario_selected.rol === 4 || this.props.usuario_selected.rol === 5) ? null : []
        const { setFieldsValue } = this.props.form

        let plaza_id = [];
        if(value != null && (this.props.usuario_selected.rol === 4 || this.props.usuario_selected.rol === 5))
        {
            plaza_id = [value];
        }
        else {
            plaza_id.push(value);
        }

        state.plazaSelected = null
        state.disableComboDrive = true;

        if (value !== undefined && plaza_id.length > 0) {
            state.plazaSelected = plaza_id
            this.setState(state, () => {
                this.updateSitios();
            })
        }

        setFieldsValue({
            // supervisores: [],
            drive: drive_temp
        })

        this.setState(state)
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de generar un pedido.
     */
    handleCancel = () => {
        this.props.esconderModal(false);
        this.props.form.resetFields();
        this.setState({
            plazaSelected: null,
            disableComboDrive: true,
        })
    }

    /**
     * Función que se ejecuta cuando se confirma edición de usuario
     * @return: nada.
     */
    showConfirm = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                confirm({
                    title: 'Confirmar',
                    content: <div><b>¿Está seguro de editar el usuario?</b> Se cambiará la información actual del usuario y su información.</div>,
                    okText: 'Aceptar',
                    cancelText: 'Cancelar',
                    okButtonProps: {
                        id: 'boton-aceptar-confirmacion-usuarios-form',
                    },
                    cancelButtonProps: {
                        id: 'boton-cancelar-confirmacion-usuarios-form',
                    },
                    onOk: () => {
                        this.setState({ cargando: true, bloquearBotones: true }, this.editarUsuario)
                    },
                });
            }
        });
    }

    /**
     * Función que se ejecuta para editar el registro de usuario
     * @return: nada.
     */
    editarUsuario = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let objEnviar = {};
                let mensaje = this.props.modo === 'configurar' ? 'configurado' : 'editado';

                // Validar que usuario_selected exista antes de acceder
                const usuario = this.props.usuario_selected;
                if (!usuario) {
                    openNotification(
                        "No se encontró el usuario seleccionado.",
                        "Error al editar usuario",
                        false
                    );
                    return;
                }
                
                if ([4, 5].includes(usuario.rol))
                {
                    objEnviar.sitios = [values.drive];
                } 
                else if ([2, 3, 6, 7].includes(usuario.rol)) 
                {
                    objEnviar.sitios = values.drive;
                }

                if (usuario.rol !== 1)
                {
                    if(!Array.isArray(values.plaza))
                    {
                        objEnviar.plaza = [values.plaza];
                    } else {
                        objEnviar.plaza = values.plaza.filter(x => x !== null)
                    }
                }
                objEnviar.segmento = values.segmento;
                
                this.setState({ cargando: true }, () => {
                    UsuariosRequest.ConfigurarUsuario(usuario.id, objEnviar)
                        .then(response => {
                            this.setState({
                                cargando: false,
                                bloquearBotones: false,
                                plazaSelected: null
                            });
                            this.props.esconderModal(true);
                            this.props.form.resetFields();
                            openNotification(
                                `Se ha ${mensaje} el usuario correctamente.`,
                                `Usuario ${mensaje} correctamente`,
                                true
                            );
                        })
                        .catch(err => {
                            this.setState({ cargando: false, bloquearBotones: false })
                            openNotification(
                                "Ha ocurrido un error al configurar al usuario.",
                                "Error al configurar usuario",
                                false
                            );
                        });
                })
            }
        })
    }

    onchangeSegmento = (value) => {
        let state = { ...this.state }
        state.segmentoSelected = value;
        state.disableComboDrive = false;
        state.cargandoDrive = true;
        state.drivesSelected = [];
        state.arrDrives = [];
        state.usuarioInteraccion = true;
        this.props.form.setFieldsValue({ drive: []});
        this.setState(state, () => {
            if (state.segmentoSelected) {
                this.updateSitios();
            } else {
                state.arrDrives = [];
                state.cargandoDrive = false;
                this.setState(state);
            }
        });
    }

    updateSitios = () => {
        let state = { ...this.state }
        const plazaSelected = state.plazaSelected ?? this.props.usuario_selected.plaza;
        const segmentoSelected = state.segmentoSelected ?? this.props.usuario_selected.segmento;

        CatalogosRequest.ListarSitios(plazaSelected, segmentoSelected).then(response => {
            state.arrDrives = response.data;
            state.cargandoDrive = false;
            state.disableComboDrive = false;
            this.setState(state)
        })
        .catch(err => {
            state.cargandoDrive = false;
            openNotification(
                "Ha ocurrido un error al cargar los drives de la plaza.",
                "Error al cargar drives",
                false
            )
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const usuario = this.props.usuario_selected;
        const modo = this.props.modo;
        let initial_drive;
        let required_drive;
        
        if (usuario !== undefined && usuario !== null) {
            if (modo === 'configurar') {
                initial_drive = (usuario.rol === 4 || usuario.rol === 5) ? null : []
            } else {
                initial_drive = (usuario.rol === 4 || usuario.rol === 5) ? usuario.sitio[0].id : usuario.sitio.map(item => item.id)
            }
            if (modo !== 'ver') {
                required_drive = usuario.rol === 2 ? false : localStorage.getItem("role") !== 'SuperAdmin';
            }
        }

        return(
            <div>
                <Modal
                    title={modo === 'configurar' ? 'Configurar usuario' : modo === 'ver' ? 'Ver detalle de usuario' : 'Editar usuario'}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.showConfirm}
                    width={this.state.isPos ? "90%" : "60%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-form-usuarios"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={this.props.modo !== "ver" ? 'btnVerCrearGuardar' : 'display-none'}
                                key="submit"
                                id="boton-guardar-form-usuarios"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={() => {
                                    modo === 'configurar' ? this.editarUsuario() : this.showConfirm()
                                }}
                            >
                                Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                    >
                        <Form onSubmit={this.showConfirm}>
                            <Row gutter={12}>
                                <Col span={8}>
                                    <div className="center-only">{this.props.modo !== "ver" ? 'Nombre' : <b>Nombre</b>}</div>
                                    <Input
                                        id="input-nombre-form-usuarios"
                                        type="text"
                                        value={usuario !== null && usuario.nombre}
                                        className='disableBtn'
                                    />
                                </Col>
                                <Col span={8}>
                                    <div className="center-only">{this.props.modo !== "ver" ? 'Usuario' : <b>Usuario</b>}</div>
                                    <Input
                                        id="input-usuario-form-usuarios"
                                        type="text"
                                        value={usuario !== null && usuario.username}
                                        className='disableBtn'
                                    />
                                </Col>
                                <Col span={8}>
                                    <div className="center-only">{this.props.modo !== "ver" ? 'Rol' : <b>Rol</b>}</div>
                                    <Input
                                        id="input-rol-form-usuarios"
                                        type="text"
                                        value={usuario !== null && usuario.rol_nombre}
                                        className='disableBtn'
                                    />
                                </Col>
                            </Row>
                            <br />
                            <Row gutter={12}>
                                <Col className={( ['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role")) && this.props.usuario_selected && this.props.usuario_selected.rol !== 1) ? '' : 'display-none'} span={8}>
                                    <Form.Item
                                        label={modo !== "ver" ? "Plaza" : <b>Plaza</b>}
                                        colon={modo === 'ver' ? false : true}
                                    >
                                        {getFieldDecorator('plaza', {
                                            rules: [
                                                {
                                                    required: modo === 'ver' ? false : localStorage.getItem("role") !== 'SuperAdmin',
                                                    message: 'Por favor, seleccione una plaza.'
                                                },
                                            ],
                                            initialValue: (
                                                modo === 'configurar' ? null : (usuario !== undefined && usuario !== null) ? usuario.plaza.map(item => item) : null
                                            )
                                        })(
                                            <Select
                                                id="select-plaza-form-usuarios"
                                                showSearch
                                                style={{ width: "100%" }}
                                                defaultActiveFirstOption={false}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                optionFilterProp="children"
                                                onChange={this.onChangePlaza}
                                                allowClear
                                                showArrow={modo === 'ver' ? false : true}
                                                disabled={modo === 'ver' ? true : false}
                                                className={modo === 'ver' ? 'disableInput' : ''}
                                                mode={(usuario !== undefined && usuario !== null) ? (usuario.rol !== 4 && usuario.rol !== 5) ? 'multiple' : '' : ''}
                                            >
                                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrPlazas.length > 0 &&
                                                    this.state.arrPlazas.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj.id}
                                                                value={obj.id}>
                                                                {obj.nombre}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                                </Select>
                                            )}
                                    </Form.Item>
                                </Col>
                                <Col className={['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role")) ? '' : 'display-none'} span={8}>
                                    <Form.Item
                                        label={modo !== "ver" ? "Segmento" : <b>Segmento</b>}
                                        colon={modo === 'ver' ? false : true}
                                    >
                                        {
                                            getFieldDecorator('segmento', {
                                                rules: [
                                                    {
                                                        required:  modo === 'ver' ? false : true,
                                                        message: 'Por favor, seleccione un segmento.'
                                                    },
                                                ],
                                                initialValue: (
                                                    modo === 'configurar' ? null : (usuario !== undefined && usuario !== null) ? usuario.segmento : null
                                                )
                                            })
                                            (
                                                <Select
                                                    id="select-segmento-form-usuarios"
                                                    showSearch
                                                    style={{ width: "100%" }}
                                                    defaultActiveFirstOption={false}
                                                    notFoundContent='No hay opciones'
                                                    placeholder="Seleccionar..."
                                                    optionFilterProp="children"
                                                    onChange={this.onchangeSegmento}
                                                    allowClear
                                                    showArrow={modo === 'ver' ? false : true}
                                                    disabled={modo === 'ver' ? true : false}
                                                    className={modo === 'ver' ? 'disableInput' : ''}
                                                >
                                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                                    {
                                                        this.state.arrSegementos.length > 0 &&
                                                        this.state.arrSegementos.map(obj => {
                                                            return (
                                                                <Option
                                                                    key={obj.id}
                                                                    value={obj.id}>
                                                                    {obj.nombre}
                                                                </Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                {this.state.mostrarDrive &&
                                    <Col span={8}>
                                        <Form.Item
                                            label={modo !== "ver" ? "Punto de venta" : <b>Punto de venta</b>}
                                            colon={modo === 'ver' ? false : true}
                                        >
                                            {
                                                getFieldDecorator('drive', {
                                                    rules: [
                                                        {
                                                            required: required_drive,
                                                            message: 'Por favor, seleccione un punto de venta.'
                                                        },
                                                    ],
                                                    initialValue: (
                                                        initial_drive
                                                    )
                                                })
                                                (
                                                    
                                                        this.state.cargandoDrive ? (
                                                            <Spin
                                                                tip="Cargando..."
                                                                indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                                                                spinning={this.state.cargandoDrive}
                                                                style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                                                            >
                                                            </Spin>
                                                        )
                                                        : (
                                                            <Select
                                                                id="select-drive-form-usuarios"
                                                                showSearch
                                                                style={{ width: "100%" }}
                                                                defaultActiveFirstOption={false}
                                                                notFoundContent='No hay opciones'
                                                                placeholder="Seleccionar..."
                                                                optionFilterProp="children"
                                                                allowClear
                                                                showArrow={modo === 'ver' ? false : true}
                                                                disabled={this.state.disableComboDrive}
                                                                className={this.state.disableComboDrive ? 'disableInput' : ''}
                                                                mode={(usuario !== undefined && usuario !== null) ? (usuario.rol !== 4 && usuario.rol !== 5) ? 'multiple' : '' : ''}
                                                            >
                                                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                                                {
                                                                    this.state.arrDrives.length > 0 &&
                                                                    this.state.arrDrives.map(obj => {
                                                                        return (
                                                                            <Option
                                                                                key={obj.id}
                                                                                value={obj.id}>
                                                                                {obj.nombre}
                                                                            </Option>
                                                                        )
                                                                    })
                                                                }
                                                            </Select>
                                                        )
                                                )
                                            }
                                        </Form.Item>
                                    </Col>
                                }
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
            </div>
        );
    }
}

export default Form.create()(NewFormUsuarios);